import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormFeedback,
  Input,
  Label,
  Modal,
  Row,
  Tooltip,
  UncontrolledTooltip
} from 'reactstrap';
import { io } from 'socket.io-client';
import moment from 'moment';
import 'react-dropzone-uploader/dist/styles.css';
import { withTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone-uploader';
import Resizer from 'react-image-file-resizer';
import _, { map } from 'lodash';
import { createPicker } from 'picmo';

import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PropTypes from 'prop-types';

import axios from 'axios';

import Webcam from 'react-webcam';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';
import i18n from '../../i18n';
import languageList from '../../common/languageList.json';
import { ReactComponent as IconoMundo } from '../../assets/images/icono_mundo.svg';
import TextoConEnlaces from '../../components/Common/TextoConEnlaces';
import 'assets/scss/estilosBurbuja.scss';

const socket = io(process.env.REACT_APP_API_DOMAIN, {
  withCredentials: true,
  transports: ['websocket']
});
const params = new URLSearchParams(window.location.search);
const region = params.get('origen') || 'europe';
const hash = params.get('sgn');

const Chat = (props) => {
  const { t } = props;
  document.title = 'Chat - Journeytok';
  const [messageBox, setMessageBox] = useState(null);
  const [curMessage, setcurMessage] = useState('');
  const [hotel, setHotel] = useState('');
  const [fotoHotel, setFotoHotel] = useState('');
  const [mensajes, setMensajes] = useState([]);
  const [usuario, setUsuario] = useState({ uuid: '', nombre: '' });
  const [idMensaje, setIdMensaje] = useState(0);
  const [modalCamara, setModalCamara] = useState(false);
  const [modalImage, setModalImage] = useState(false);
  const [uuid, setUUID] = useState(params.get('uuid') || '');
  const [idLocal, setIdLocal] = useState(params.get('id'));
  const idDiagrama = params.get('diag') >= 0 ? params.get('diag') : -1;
  const diagramaWhatsapp = params.get('wa') || 0;
  const webcamRef = useRef(null);
  const [mailLogin, setMailLogin] = useState('');
  const [phoneLogin, setPhoneLogin] = useState('');
  const [expandForm, setExpandForm] = useState();
  const [curNombre, setCurNombre] = useState('');
  const [respuestasRapidas, setRespuestasRapidas] = useState([]);
  const [mostrarFin, setMostrarFin] = useState(false);
  const [nodos, setNodos] = useState();
  const [enlaces, setEnlaces] = useState();
  const [idActual, setIdActual] = useState();
  const [camino, setCamino] = useState([]);
  const [textoDiagramas, setTextoDiagramas] = useState([]);
  const [idioma, setIdioma] = useState('');
  const [selectedLang, setSelectedLang] = useState('');
  const [menu, setMenu] = useState(false);
  const [idiomas, setIdiomas] = useState({});
  const [bgColorCabecera, setBGColorCabecera] = useState('#f8f8fb');
  const [textColorCabecera, setTextColorCabecera] = useState('white');
  const [mostrarCopy, setMostrarCopy] = useState(true);
  const [menuEmojis, setMenuEmojis] = useState(false);
  const [emailValidado, setEmailValidado] = useState(false);
  const [idiomaTelefono, setIdiomaTelefono] = useState('es');
  const [cabecera, setCabecera] = useState('');
  const [idiomaDetectado, setIdiomaDetectado] = useState(false);
  const [iaLocal, setIALocal] = useState(false);
  const [contactar, setContactar] = useState(false);
  const [colaRespuestas, setColaRespuestas] = useState([]);
  const [tempID, setTempID] = useState('');
  const [ultimaPregunta, setUltimaPregunta] = useState(false);
  const [ultimaRespuesta, setUltimaRespuesta] = useState(false);
  const mensajeEnviarIA = useRef('');
  const refTimeout = useRef(null);
  const wrapperRef = useRef(null);
  const botonRef = useRef(null);
  const textArea = useRef();

  async function publicarEstadisticas(estadistica) {
    try {
      const necesarioEstadisticas = {
        idLocal,
        idDiagrama: textoDiagramas.id,
        idioma,
        estadistica
      };
      await axios.post('/api/guardarEstadisticas', necesarioEstadisticas);
      // console.log(result);
    } catch (error) {
      // console.log(error)
    }
  }

  function generaColorTexto(colorFondo) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorFondo);
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    const brightness = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
    const textColour = (brightness > 125) ? 'black' : 'white';
    setTextColorCabecera(textColour);
  }

  function useDetectarSiPulsacionDentro(ref, refBoton) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref?.current && !ref?.current?.contains(event?.target)) {
          if (refBoton?.current && !refBoton?.current?.contains(event?.target)) {
            setMenuEmojis(false);
          }
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [wrapperRef, botonRef]);
  }

  useDetectarSiPulsacionDentro(wrapperRef, botonRef);

  const cargaDatos = async () => {
    let ln = '';
    let registrado = false;
    let ia = false;
    if (idioma === '') {
      ln = localStorage.getItem('i18nextLngx');
    } else {
      ln = idioma;
    }
    let idUncrypted = idLocal;
    let posibleContactar = false;
    if (uuid !== null && hash !== null) {
      try {
        const respuesta = await axios.get(`/api/cargaInicial?wjih=${idLocal}&ukqp=${uuid}&aihm=7727&sgn=${hash}&origen=${region}`);
        const { data } = respuesta;
        if (data.length !== 4) {
          throw new Error('Error loadgin data');
        }
        setHotel(data[2].denominacion);
        setFotoHotel(data[2].imgHotel);
        if (data[2].color) {
          setBGColorCabecera(data[2].color);
          generaColorTexto(data[2].color);
        } else {
          generaColorTexto(bgColorCabecera);
        }
        setMensajes(data[0].mensajes);
        setUsuario({ uuid, nombre: data[1].nombre });
        setIdLocal(idUncrypted);
        ia = data[2].chatbotIA;
        registrado = true;
        if (!data[2].chatbotIA) posibleContactar = true;
        socket.emit('iniciaChat', {
          idSocket: socket.id,
          idCliente: uuid,
          idLocal,
          origen: region,
        });
        if (!data[0].chatbotActivado && 'chatbotActivado' in data[0]) {
          setContactar(true);
          setIALocal(false);
        } else {
          setIALocal(data[2].chatbotIA || false);
        }
      } catch (error) {
        // console.log(error);
      }
    } else {
      setUsuario({ uuid: 'unlogged', nombre: '' });
      try {
        const respuesta = await axios.get(`/api/cargaLocalChat?wjih=${idLocal}`);
        const { data } = respuesta;
        setFotoHotel(data[0].imgHotel);
        setHotel(data[0].denominacion);
        if (data[0].color) {
          setBGColorCabecera(data[0].color);
          generaColorTexto(data[0].color);
        } else {
          generaColorTexto(bgColorCabecera);
        }
        if (data[0].cabecera) {
          setCabecera(data[0].cabecera);
        }
        setIALocal(data[0].chatbotIA || false);
        ia = data[0].chatbotIA;
        idUncrypted = data[0].idLocal;
        setIdLocal(idUncrypted);
        setTempID(data[2]);
        socket.emit('iniciaChat', {
          idSocket: socket.id,
          idCliente: data[2],
          idLocal: idUncrypted,
          origen: region,
        });
      } catch (e) {
        // console.log(e);
      }
    }
    try {
      const chatbot = await axios.get(`/api/cargarDiagramaChat?id=${idUncrypted}&diag=${idDiagrama}&wa=${diagramaWhatsapp}`);
      const respuestasRa = await axios.get(`/api/respuestasRapidas?id=${idUncrypted}`);
      const rr = respuestasRa.data;
      const { error } = rr;
      if ((error || chatbot.data.error || Object.keys(chatbot.data.diagrama).length === 0)) {
        if (!registrado && !ia) {
          const mensajeLogin = {
            tipo: 'formularioLogin',
            id: `login${idMensaje}`
          };
          setMensajes([mensajeLogin]);
        }
        setContactar(posibleContactar);
      } else {
        const arrayRespuestas = [];
        Object.keys(rr.respuestasRapidas).forEach(r => {
          arrayRespuestas.push(...rr.respuestasRapidas[r]);
        });
        const claveIdiomas = Object.keys(chatbot.data.diagrama);
        const nuevosIdiomas = _.pick(languageList, claveIdiomas);
        setIdiomas(nuevosIdiomas);
        setTextoDiagramas(chatbot.data.diagrama);
        arrayRespuestas.forEach((r, index) => { r.id = index; });
        setRespuestasRapidas(arrayRespuestas);
        if (chatbot.data.diagrama[ln]) {
          setNodos(chatbot.data.diagrama[ln].nodes);
          setEnlaces(chatbot.data.diagrama[ln].links);
          setIdActual('inicio');
          setIdioma(ln);
        } else {
          const alt = Object.keys(nuevosIdiomas)[0];
          setNodos(chatbot.data.diagrama[alt].nodes);
          setEnlaces(chatbot.data.diagrama[alt].links);
          setIdActual('inicio');
          setIdioma(alt);
        }
        setMostrarCopy(true);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  function formatearFechaHora(fechaHora) {
    return moment.utc(fechaHora).local().format('DD/MM/yyyy HH:mm:ss');
  }

  const scrollToBottom = () => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  };

  function avisaMensajesLeidos() {
    socket.emit('mensajesLeidos', {
      idSocket: socket.id,
      ukqp: uuid,
      wjih: idLocal,
      source: 'chat'
    });
  }

  const reiniciarConversacion = () => {
    setMostrarFin(false);
    if (idActual !== 'inicio') setIdActual('inicio');
    // eslint-disable-next-line no-use-before-define
    else generaNuevoMensaje(idActual);
  };

  function generaNuevoMensaje(id) {
    if (id && nodos) {
      const nodoActual = nodos.filter(nodo => nodo.id === id)[0];
      let noMostrarMensajeFin = true;
      let nuevoMensaje = [];
      let completo = false;
      const temp = {
        enviadoPor: 'Automatico',
        id: idMensaje + 1,
        tipo: 'escribiendo'
      };
      if (nodoActual.data.mensaje) {
        completo = true;
        if (typeof nodoActual.data.mensaje === typeof '') nodoActual.data.mensaje = [nodoActual.data.mensaje];
        setMensajes([...mensajes, temp]);
        nodoActual.data.mensaje.forEach((mensaje, indice) => {
          if (mensaje) {
            setTimeout(() => {
              const nuevo = {
                enviadoPor: 'Automatico',
                horaEnvio: moment(moment.now()).toISOString(),
                id: idMensaje + indice,
                mensaje,
                botones: indice + 1 === nodoActual.data.mensaje.length ?
                  nodoActual.data.respuestas : [],
                idNodo: `${nodoActual.data.id}` || ''
              };
              nuevoMensaje = [...nuevoMensaje, nuevo];
              if (indice + 1 !== nodoActual.data.mensaje.length) {
                setMensajes([...mensajes, ...nuevoMensaje, temp]);
              } else {
                setMensajes([...mensajes, ...nuevoMensaje]);
              }
              setIdMensaje(idMensaje + nuevoMensaje.length);
            }, 2000 * (indice + 1));
          }
        });
      }
      if (nodoActual.data.reiniciar) {
        setTimeout(() => reiniciarConversacion(), 2500);
      } else if (nodoActual.data.contactar) {
        if (uuid === '') {
          const nuevoMensajeRespuesta = {
            tipo: 'formularioLogin',
            id: idMensaje + 1,
          };
          if (completo) {
            setTimeout(() => setMensajes(
              [...mensajes, ...nuevoMensaje, nuevoMensajeRespuesta]
            ), 5000);
          } else {
            setTimeout(() => setMensajes([...mensajes, nuevoMensajeRespuesta]), 3000);
          }
          setIdMensaje(idMensaje + nuevoMensaje.length + 1);
        } else {
          const nuevoMensajeRespuesta = {
            enviadoPor: 'Automatico',
            horaEnvio: moment(moment.now()).toISOString(),
            id: idMensaje + 1,
            mensaje: `${t('Mensaje saludo hotel', { nombre: usuario.nombre })}`
          };
          if (completo) {
            setTimeout(() => setMensajes(
              [...mensajes, ...nuevoMensaje, nuevoMensajeRespuesta]
            ), (nuevoMensaje.length + 1) * 1000);
          } else {
            setTimeout(() => setMensajes([...mensajes, nuevoMensajeRespuesta]), 1000);
          }
          setIdMensaje(idMensaje + nuevoMensaje.length + 1);
        }
      } else if (nodoActual.data.redirect) {
        setTimeout(() => {
          if (!nodoActual.data.url.includes('https://') && !nodoActual.data.url.includes('http://') && !nodoActual.data.url.includes('whatsapp://')) {
            window.open(`http://${nodoActual.data.url}`, '_blank', 'noreferrer');
          } else {
            window.open(nodoActual.data.url, '_blank', 'noreferrer');
          }
        }, parseInt(nodoActual.data.timeoutRedirect, 10) * 1000);
        noMostrarMensajeFin = false;
      } else if (nodoActual.data.rr) {
        const msg = respuestasRapidas.filter(r => r.titulo === nodoActual.data.rr)[0]
          .contenido[idioma];
        const nuevoMensajeRespuesta = {
          enviadoPor: 'Automatico',
          horaEnvio: moment(moment.now()).toISOString(),
          id: idMensaje + 1,
          mensaje: msg
        };
        if (completo) {
          setTimeout(() => setMensajes(
            [...mensajes, ...nuevoMensaje, nuevoMensajeRespuesta]
          ), (nodoActual.data.mensaje.length + 1) * 2000);
        } else {
          setTimeout(() => setMensajes([...mensajes, nuevoMensajeRespuesta]), 2000);
        }
        setIdMensaje(idMensaje + 2);
        noMostrarMensajeFin = false;
      }
      if (!mostrarFin && !noMostrarMensajeFin) {
        setMostrarFin(true);
        setTimeout(() => {
          setIdActual('fin');
        }, nodoActual.data.mensaje.length * 2000 + 5000);
      }
    }
  }

  const changeLanguageAction = lang => {
    // set language as i18n
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    setSelectedLang(lang);
    if (textoDiagramas[lang]) {
      setNodos(textoDiagramas[lang].nodes);
      setEnlaces(textoDiagramas[lang].links);
      setIdioma(lang);
    } else {
      setNodos(textoDiagramas.en.nodes);
      setEnlaces(textoDiagramas.en.links);
      setIdioma('en');
    }
  };

  useEffect(() => {
    if (idioma !== '') {
      if (idActual !== 'inicio') {
        setIdActual('inicio');
      } else {
        generaNuevoMensaje('inicio');
      }
    }
  }, [idioma]);

  const toggle = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    generaNuevoMensaje(idActual);
  }, [idActual]);

  function onFocus() {
    avisaMensajesLeidos();
  }

  function onBotonChat(idPregunta, idMsg, texto) {
    let idTexto = '';
    switch (idMsg) {
      case 'inicio':
        idTexto = `nodo0-${idPregunta}`;
        break;
      case 'fin':
        idTexto = `nodo1-${idPregunta}`;
        break;
      case 'reiniciarContactar':
        if (idPregunta === 0) idTexto = 'reiniciar';
        else idTexto = 'contactar';
        break;
      default:
        idTexto = `nodo${idMsg}-${idPregunta}`;
    }
    if (idTexto !== 'reiniciar' && idTexto !== 'contactar') {
      publicarEstadisticas(idTexto);
      setCamino([...camino, idTexto]);
      const enlace = enlaces.filter(e => e.input === idTexto)[0];
      const nuevoID = enlace.output.split('nodo')[1];
      const nuevoMensaje = {
        enviadoPor: 'unlogged',
        horaEnvio: moment(moment.now()).toISOString(),
        id: idMensaje,
        mensaje: texto,
      };
      setMensajes([...mensajes, nuevoMensaje]);
      setIdMensaje(idMensaje + 1);
      setIdActual(nuevoID);
    } else if (idTexto === 'contactar') {
      if (uuid === '') {
        const nuevoMensaje = {
          tipo: 'formularioLogin',
          id: idMensaje,
        };
        setMensajes([...mensajes, nuevoMensaje]);
        setIdMensaje(idMensaje + 1);
      } else {
        const nuevoMensaje = {
          enviadoPor: 'Automatico',
          horaEnvio: moment(moment.now()).toISOString(),
          id: idMensaje,
          mensaje: `${t('Mensaje saludo hotel', { nombre: usuario.nombre })}`
        };
        setMensajes([...mensajes, nuevoMensaje]);
        setIdMensaje(idMensaje + 1);
      }
    } else if (idTexto === 'reiniciar') {
      reiniciarConversacion();
      publicarEstadisticas('reiniciar');
      setCamino([...camino, 'reiniciar']);
    }
  }

  useEffect(() => {
    cargaDatos();
    if (uuid) {
      window.addEventListener('focus', onFocus);
      document.addEventListener('focus', onFocus);
      window.addEventListener('visibilitychange', onFocus);
    }
    const currentLanguage = localStorage.getItem('i18nextLng');
    setSelectedLang(currentLanguage);
    if (currentLanguage && currentLanguage !== 'en') setIdiomaTelefono(currentLanguage);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('focus', onFocus);
      window.removeEventListener('visibilitychange', onFocus);
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [mensajes]);

  useEffect(() => {
    if (uuid) {
      window.addEventListener('focus', onFocus);
      document.addEventListener('focus', onFocus);
      window.addEventListener('visibilitychange', onFocus);
    }
  }, [uuid]);

  const generarRespuestaIA = async (mensaje) => {
    if (!iaLocal) return [false];
    try {
      let ultimaPreguntaEnviada = false;
      if (ultimaPregunta && ultimaRespuesta) {
        ultimaPreguntaEnviada = { pregunta: ultimaPregunta, respuesta: ultimaRespuesta };
      }
      const datos = {
        mensaje,
        idLocal,
        idioma: idiomaDetectado || false,
        uuid: uuid || tempID,
        ultimaPregunta: ultimaPreguntaEnviada
      };
      const response = await axios.post('/api/generarRespuestaIAWebchat', datos);
      if (response.data.error) {
        return [false];
      }
      setIdiomaDetectado(response.data.idioma);
      setContactar(!!response.data.extra.contactar);
      setUltimaPregunta(mensaje);
      setUltimaRespuesta(response.data.mensaje);
      return [response.data.mensaje, !!response.data.extra.contactar];
    } catch (e) {
      // console.log(e);
    }
    return [false];
  };

  const enviarMensaje = () => {
    const nuevoMensaje = {
      enviadoPor: uuid || 'unlogged',
      mensaje: curMessage,
      horaEnvio: moment(moment.now()).toISOString(),
      imgPre: '',
      source: 'chat',
      id: idMensaje,
    };
    setMensajes([...mensajes, nuevoMensaje]);
    socket.emit('envioMensajeChat', {
      idSocket: socket.id,
      ukqp: uuid || tempID,
      wjih: idLocal,
      mensaje: curMessage,
      horaEnvio: moment.now(),
      imgAdjunto: '',
      source: 'chat',
      origen: region,
      contactar,
      finChatbot: contactar
    });
    const temp = {
      enviadoPor: 'Automatico',
      id: idMensaje + 1,
      tipo: 'escribiendo'
    };
    if (!iaLocal && nodos && !contactar) {
      setMensajes([...mensajes, nuevoMensaje, temp]);
      setTimeout(async () => {
        const respuesta = {
          enviadoPor: 'Chatbot',
          horaEnvio: moment(moment.now()).toISOString(),
          id: `respuestaAutomatica${idMensaje}`,
          mensaje: t('Hola, ¿quieres empezar de nuevo o quieres contactar con el personal del hotel?'),
          idNodo: 'reiniciarContactar',
          botones: [
            {
              id: 0,
              texto: t('Reiniciar conversacion'),
            },
            {
              id: 1,
              texto: t('Contactar con el hotel')
            }
          ]
        };
        setMensajes([...mensajes, nuevoMensaje, respuesta]);
      }, 1000);
    } else if (iaLocal && !contactar) {
      if (refTimeout.current) {
        clearTimeout(refTimeout.current);
      }
      if (mensajeEnviarIA.current) {
        mensajeEnviarIA.current = `${mensajeEnviarIA.current} ${curMessage}`;
      } else {
        mensajeEnviarIA.current = curMessage;
      }
      refTimeout.current = setTimeout(async () => {
        const mensaje = mensajeEnviarIA.current;
        const copiaMensajes = [...mensajes].filter(m => m.tipo !== 'escribiendo');
        setMensajes([...copiaMensajes, nuevoMensaje, temp]);
        mensajeEnviarIA.current = '';
        const respuestaIA = await generarRespuestaIA(mensaje);
        if (respuestaIA[0]) {
          const respuesta = {
            enviadoPor: 'Chatbot',
            horaEnvio: moment(moment.now()).toISOString(),
            id: `respuestaAutomatica${idMensaje}`,
            mensaje: respuestaIA[0],
          };
          socket.emit('envioMensajeChat', {
            idSocket: socket.id,
            ukqp: uuid || tempID,
            wjih: idLocal,
            mensaje: respuestaIA[0],
            horaEnvio: moment.now(),
            imgAdjunto: '',
            source: 'chat',
            origen: region,
            contactar: uuid && respuestaIA[1],
            finChatbot: uuid && respuestaIA[1],
            esMensajeIA: true
          });
          if (respuestaIA[1] && !uuid) {
            const mensajeLogin = {
              tipo: 'formularioLogin',
              id: `login${idMensaje}`
            };
            setColaRespuestas([respuesta, mensajeLogin]);
          } else {
            setColaRespuestas([respuesta]);
          }
        } else {
          setMensajes([...copiaMensajes, nuevoMensaje]);
          setContactar(true);
        }
      }, 5000);
    } else if (!contactar) {
      const respuesta = {
        enviadoPor: 'Automatico',
        horaEnvio: moment(moment.now()).toISOString(),
        id: `respuestaAutomatica${idMensaje}`,
        mensaje: t('Hola, ¿contactar con el personal?'),
        idNodo: 'reiniciarContactar',
        botones: [
          {
            id: 1,
            texto: t('Contactar con el hotel')
          }
        ]
      };
      setMensajes([...mensajes, nuevoMensaje, respuesta]);
    }
    setIdMensaje(idMensaje + 1);
    setcurMessage('');
    textArea.current?.blur();
  };

  useEffect(() => {
    if (colaRespuestas.length > 0) {
      const copiaMensajes = [...mensajes, ...colaRespuestas].filter(m => m.tipo !== 'escribiendo');
      setMensajes(copiaMensajes);
      setColaRespuestas([]);
    }
  }, [colaRespuestas]);

  const resizeImage = (file, small) => new Promise(resolve => {
    if (!small) {
      Resizer.imageFileResizer(file, 800, 600, 'JPEG', 100, 0, uri => { resolve(uri); }, 'base64');
    } else {
      Resizer.imageFileResizer(file, 80, 60, 'JPEG', 100, 0, uri => { resolve(uri); }, 'base64');
    }
  });

  const enviarImagen = async (file) => {
    const img = await resizeImage(file);
    const pre = await resizeImage(file, true);
    const nuevoMensaje = {
      enviadoPor: uuid || tempID,
      mensaje: '',
      horaEnvio: moment(moment.now()).toISOString(),
      imgPre: pre,
      imgAdjunto: img,
      source: 'chat',
      id: idMensaje,
    };
    socket.emit('envioMensajeChat', {
      idSocket: socket.id,
      ukqp: uuid,
      wjih: idLocal,
      mensaje: '',
      imgAdjunto: img,
      imgPre: pre,
      horaEnvio: moment.now(),
      source: 'chat',
      origen: region,
      contactar
    });
    setMensajes([...mensajes, nuevoMensaje]);
    setIdMensaje(idMensaje + 1);
    setModalCamara(false);
    setModalImage(false);
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    const byteString = atob(imageSrc.split(',')[1]);

    // separate out the mime component
    const mimeString = imageSrc.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const imgSrc = new Blob([ab], { type: mimeString });
    enviarImagen(imgSrc);
  }, [webcamRef]);

  socket.on('respondeChat', msg => {
    const nuevoMensaje = {
      enviadoPor: msg.enviadoPor,
      mensaje: msg.mensaje,
      horaEnvio: msg.hora,
      source: 'chat',
      id: idMensaje,
    };
    setIdMensaje(idMensaje + 1);
    setMensajes([...mensajes, nuevoMensaje]);
  });

  const cargarImagen = async (mensaje) => {
    try {
      const response = await axios.get(`/api/cargarImagen?file=${mensaje.imgAdjunto}`);
      const imagen = `data:image/jpeg;base64,${response.data.imagen}`;
      const index = mensajes.findIndex((msg) => msg.id === mensaje.id);
      const nuevosMensajes = [...mensajes];
      nuevosMensajes[index].imgAdjunto = imagen;
      setMensajes(nuevosMensajes);
    } catch (error) {
      // console.log(error);
    }
  };

  const validarEmailReal = async () => {
    try {
      const response = await axios.post('/backend/compruebaEmailValido', { email: mailLogin });
      const { data } = response;
      if (data.valido === true) {
        setEmailValidado(true);
      } else {
        setEmailValidado(false);
      }
    } catch (e) {
      // console.log(e);
      setEmailValidado(false);
    }
  };

  const validarEmail = async () => {
    if (!mailLogin) return false;
    try {
      const response = await axios.get(`/api/existeConEmail?email=${mailLogin}&idLocal=${idLocal}&platform=${region}`);
      const { data } = response;
      return data.data;
    } catch (error) {
      // console.log(error);
    }
    return false;
  };

  const validarPhone = async () => {
    if (!phoneLogin) return false;
    try {
      const response = await axios.get(`/api/existeConTlf?tlf=${phoneLogin}&idLocal=${idLocal}&platform=${region}`);
      const { data } = response;
      return data.data;
    } catch (error) {
      // console.log(error);
    }
    return false;
  };

  const comprobarLogin = async () => {
    const tlfValido = await validarPhone();
    const emailValido = await validarEmail();
    if (tlfValido) {
      setUUID(tlfValido.id);
      setUsuario({ uuid: tlfValido.id, nombre: tlfValido.nombre });
      const nuevoMensaje = {
        nviadoPor: 'Automatico',
        mensaje: t('Mensaje saludo hotel', { nombre: tlfValido.nombre }),
        horaEnvio: moment(moment.now()).toISOString(),
        source: 'chat',
        id: idMensaje,
      };
      setContactar(true);
      setIdMensaje(idMensaje + 1);
      setMensajes([...mensajes, nuevoMensaje]);
      axios.post('/api/reasignaConversacionAnonima', { tempID, idCliente: tlfValido.id, idLocal, plataforma: region });
      socket.emit('iniciaChat', {
        idSocket: socket.id,
        idCliente: tlfValido.id,
        idLocal,
        origen: region,
      });
    } else if (emailValido) {
      setUUID(emailValido.id);
      setUsuario({ uuid: emailValido.id, nombre: emailValido.nombre });
      const nuevoMensaje = {
        nviadoPor: 'Automatico',
        mensaje: t('Mensaje saludo hotel', { nombre: emailValido.nombre }),
        horaEnvio: moment(moment.now()).toISOString(),
        source: 'chat',
        id: idMensaje,
      };
      setContactar(true);
      setIdMensaje(idMensaje + 1);
      setMensajes([...mensajes, nuevoMensaje]);
      axios.post('/api/reasignaConversacionAnonima', { tempID, idCliente: emailValido.id, idLocal, plataforma: region });
      socket.emit('iniciaChat', {
        idSocket: socket.id,
        idCliente: emailValido.id,
        idLocal,
        origen: region,
      });
    } else {
      const nuevoMensaje = {
        id: `mensajeRegistro${idMensaje}`,
        tipo: 'formularioNombre'
      };
      setMensajes([...mensajes, nuevoMensaje]);
      setExpandForm(true);
    }
  };

  const registrarNuevo = async () => {
    try {
      const firstName = curNombre.substring(0, curNombre.indexOf(' '));
      const lastName = curNombre.substring(curNombre.indexOf(' ') + 1);
      const nuevoUsuario = {
        idLocal,
        usuario: {
          nombre: curNombre,
          telefono: phoneLogin,
          email: emailValidado ? mailLogin : '',
          firstName: firstName || '',
          lastName: lastName || ''
        },
        origen: 'MC'
      };
      let backend = 'backend';
      if (region === 'america') {
        backend = 'backendAM';
      }
      const response = await axios.post(`/${backend}/registraUsuarioWA`, nuevoUsuario);
      setExpandForm(false);
      setMailLogin();
      setPhoneLogin();
      setUsuario({ uuid: response.data.user, nombre: curNombre });
      setUUID(response.data.user);
      const nuevoMensaje = {
        nviadoPor: 'Automatico',
        mensaje: t('Mensaje saludo hotel', { nombre: curNombre }),
        horaEnvio: moment(moment.now()).toISOString(),
        source: 'chat',
        id: idMensaje,
      };
      axios.post('/api/reasignaConversacionAnonima', { tempID, idCliente: response.data.user, idLocal, plataforma: region });
      setContactar(true);
      setIdMensaje(idMensaje + 1);
      setMensajes([...mensajes, nuevoMensaje]);
      socket.emit('iniciaChat', {
        idSocket: socket.id,
        idCliente: response.data.user,
        idLocal,
        origen: region,
      });
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(
    () => {
      const rootElement = document.querySelector('#pickerContainer');
      if (rootElement) {
        const picker = createPicker({
          rootElement,
          categories: [
            'smileys-emotion',
            'people-body',
            'animals-nature',
            'food-drink',
            'travel-places',
            'activities',
            'objects',
            'symbols',
          ]
        });
        // The picker emits an event when an emoji is selected.
        // Do with it as you will!
        picker.addEventListener('emoji:select', event => {
          let texto = curMessage || '';
          const ta = textArea.current;
          const fin = ta.selectionEnd !== 0 ? ta.selectionEnd : texto.length;
          texto = `${texto?.slice(0, fin)}${event.emoji}${texto?.slice(fin)}`;
          ta.selectionEnd = fin + 1;
          setcurMessage(texto);
          setMenuEmojis(false);
        });
      }
    }, [menuEmojis]
  );

  return (
    <>
      <div className="page-content" style={{ padding: '0' }}>
        <Container fluid>
          <Row>
            <Col lg="12" style={{ padding: '0px' }}>
              <div className="d-lg-flex">
                <div className="w-100 user-chat">
                  <Card>
                    <div
                      className="p-3 border-bottom cabecera-webchat"
                      style={{
                        backgroundColor: bgColorCabecera,
                        color: textColorCabecera
                      }}
                    >
                      <Row>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                          <Row className="mb-2" style={{ width: '100%' }}>
                            <Col xs="auto">
                              <img
                                src={fotoHotel}
                                alt=""
                                style={{
                                  maxWidth: '60px',
                                  maxHeight: '60px',
                                  width: '100%',
                                  height: '100%',
                                  minWidth: '25px',
                                  minHeight: '25px'
                                }}
                              />
                            </Col>
                            <Col style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                              <Row>
                                <h5 className="font-size-15 mb-1">{hotel}</h5>
                              </Row>
                              <Row>
                                <h6 className="font-size-12 mb-0">{cabecera}</h6>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                        <div style={{ position: 'absolute', top: '0px', right: '0px' }}>
                          <ul className="list-inline user-chat-nav text-end mb-0" style={{ position: 'absolute', top: '0px', right: '0px' }}>
                            {idiomas && idiomas.length > 1 && (
                              <li className="list-inline-item" style={{ position: 'absolute', top: '0px', right: '0px' }}>
                                <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block" style={{ position: 'absolute', top: '0px', right: '0px' }}>
                                  <DropdownToggle className="btn header-item " tag="button" style={{ position: 'absolute', top: '0px', right: '0px' }}>
                                    <IconoMundo fill={textColorCabecera} height="30" style={{ position: 'absolute', top: '10px', right: '-10px' }} />
                                  </DropdownToggle>
                                  <DropdownMenu className="language-switch dropdown-menu-end">
                                    {map(Object.keys(idiomas), key => (
                                      <DropdownItem
                                        key={key}
                                        onClick={() => changeLanguageAction(key)}
                                        className={`notify-item ${selectedLang === key ? 'active' : 'none'}`}
                                      >
                                        <span className="align-middle">{t(idiomas[key])}</span>
                                      </DropdownItem>
                                    ))}
                                  </DropdownMenu>
                                </Dropdown>
                              </li>
                            )}
                          </ul>
                        </div>
                      </Row>
                    </div>
                    <div>
                      <div className="chat-conversation p-3 espacio-chat" style={{ /* backgroundImage: `url(${fotoHotel})`, */ backgroundRepeat: 'no-repeat' }}>
                        <ul className="list-unstyled" style={{ height: '100%' }}>
                          <PerfectScrollbar
                            style={{ width: '100%', overflowX: 'hidden' }}
                            containerRef={ref => setMessageBox(ref)}
                            options={{ suppressScrollX: true }}
                            className="custom-scroll"
                          >
                            {mensajes.map((mensaje) => {
                              if (!mensaje.tipo) {
                                return (
                                  <li
                                    className={((mensaje.enviadoPor === usuario.uuid || mensaje.enviadoPor === 'unlogged') ? 'right' : '')}
                                    key={mensaje.id}
                                    style={{ marginBottom: '15px' }}
                                  >
                                    <div className="conversation-list" style={{ display: 'flex', marginBottom: '5px' }}>
                                      {(mensaje.enviadoPor !== usuario.uuid && mensaje.enviadoPor !== 'unlogged') && (
                                      <div style={{ marginRight: '5px' }}>
                                        <svg className="journeytok" id="svgBurbujaChat" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 134.61 130.87" xmlSpace="preserve" style={{ height: '25px', width: '25px' }}>
                                          <g>
                                            <g>
                                              <g>
                                                <g>
                                                  <g>
                                                    <circle className="st0" cx="67" cy="67.93" r="49.13" />
                                                    <circle className="st1" cx="67" cy="67.93" r="49.13" />
                                                  </g>
                                                </g>
                                                <g>
                                                  <g>
                                                    <circle className="st2" cx="67" cy="67.93" r="53.95" />
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                            <g>
                                              <path className="st3" d="M67,94.28c9.35,0,17.25,5.16,19.77,12.23H47.22C49.75,99.44,57.65,94.28,67,94.28z" />
                                              <g>
                                                <defs>
                                                  <path id="SVGID_1_" d="M67,94.28c9.35,0,17.25,5.16,19.77,12.23H47.22C49.75,99.44,57.65,94.28,67,94.28z" />
                                                </defs>
                                                <clippath id="SVGID_2_">
                                                  <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
                                                </clippath>
                                                <g className="st4">
                                                  <rect x="29.32" y="103.42" className="st5" width="75.35" height="1.68" />
                                                  <rect x="29.32" y="99.93" className="st5" width="75.35" height="1.68" />
                                                  <rect x="29.32" y="96.45" className="st5" width="75.35" height="1.68" />
                                                </g>
                                              </g>
                                              <path className="st6" d="M67,74.05L67,74.05c3.73,0,6.78,3.05,6.78,6.78v14.67c0,3.73-3.05,6.78-6.78,6.78l0,0c-3.73,0-6.78-3.05-6.78-6.78V80.84C60.21,77.11,63.27,74.05,67,74.05z" />
                                              <path className="st7" d="M67,74.05L67,74.05c3.73,0,6.78,3.05,6.78,6.78v9.23l-13.57,5.15V80.84C60.21,77.11,63.27,74.05,67,74.05z" />
                                              <path className="st6" d="M67,39.28c16.86,0,21.56,11.58,21.56,25.87c0,14.29-6.94,25.87-21.56,25.87c-14.62,0-21.56-11.58-21.56-25.87C45.43,50.86,50.14,39.28,67,39.28z" />
                                              <path className="st8" d="M88.27,68.19c-5.25,0.14-5.68-2.91-5.44-13.63c0.11-5.02-3.53-7.34-6.68-7.34c-3.14,0-6.3,0.67-9.55,0.67c-3.25,0-6.4-0.67-9.55-0.67c-3.14,0-5.42,2.1-5.53,7.11c-0.12,5.02,0.6,15.02-6.03,14.48C44.25,51.63,50.14,38.74,67,38.74C83.86,38.74,89.69,52,88.27,68.19z" />
                                              <path className="st8" d="M48.47,67.6c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C45.56,66.29,46.86,67.6,48.47,67.6z" />
                                              <path className="st6" d="M44.6,62.47c1.93-0.28,3.87,2.01,4.32,5.12c0.45,3.11-0.75,5.86-2.68,6.14c-1.93,0.28-3.87-2.01-4.32-5.12C41.47,65.5,42.67,62.75,44.6,62.47z" />
                                              <path className="st8" d="M85.57,67.74c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C82.66,66.43,83.97,67.74,85.57,67.74z" />
                                              <path className="st6" d="M89.93,62.47c-1.93-0.28-3.87,2.01-4.32,5.12c-0.45,3.11,0.75,5.86,2.68,6.14c1.93,0.28,3.87-2.01,4.32-5.12C93.06,65.5,91.86,62.75,89.93,62.47z" />
                                              <path className="st9" d="M74.96,70.21c0.71,0,1.3-1.52,1.3-3.38c0-1.86-0.58-3.38-1.3-3.38c-0.71,0-1.3,1.52-1.3,3.38C73.67,68.69,74.25,70.21,74.96,70.21z" />
                                              <path className="st9" d="M58.71,70.21c0.71,0,1.3-1.52,1.3-3.38c0-1.86-0.58-3.38-1.3-3.38c-0.71,0-1.3,1.52-1.3,3.38C57.42,68.69,58,70.21,58.71,70.21z" />
                                              <path className="st7" d="M58.69,78.38c4.64,2.73,12.81,2.73,17.45,0C73.8,82.96,61.83,83.38,58.69,78.38z" />
                                              <path className="st7" d="M63.59,82.72c2,0.93,5.57,0.89,7.65,0C70.21,84.96,64.97,85.17,63.59,82.72z" />
                                              <path className="st10" d="M64.72,75.68c4.9,0.87,6.89-2.55,5.77-5.5C72.82,74.71,70.64,77.9,64.72,75.68z" />
                                              <path className="st8" d="M71.37,62.14c-0.83,0.69-2.01-0.85-1.17-1.54c2.37-1.97,7.71-2.37,10.11-0.24c0.81,0.72-0.01,1.52-0.82,0.8C77.71,59.58,73.12,60.68,71.37,62.14z" />
                                              <path className="st8" d="M62.62,62.14c0.83,0.69,2.01-0.85,1.17-1.54c-2.37-1.97-7.71-2.37-10.11-0.24c-0.81,0.72,0.01,1.52,0.82,0.8C56.28,59.58,60.87,60.68,62.62,62.14z" />
                                              <path className="st8" d="M59.76,49.59c2.99,0,5.43-2.44,5.43-5.43c0-2.99-2.44-5.43-5.43-5.43c-2.99,0-5.43,2.44-5.43,5.43C54.33,47.15,56.77,49.59,59.76,49.59z" />
                                              <path className="st8" d="M55.47,46.3c2.99,0,5.43-2.44,5.43-5.43c0-2.99-2.44-5.43-5.43-5.43c-2.99,0-5.43,2.44-5.43,5.43C50.04,43.86,52.48,46.3,55.47,46.3z" />
                                              <ellipse transform="matrix(0.9965 -0.0838 0.0838 0.9965 -2.7066 5.0962)" className="st8" cx="59.34" cy="34.78" rx="5.43" ry="5.43" />
                                              <path className="st8" d="M67,44.71c2.99,0,5.43-2.44,5.43-5.43c0-2.99-2.44-5.43-5.43-5.43c-2.99,0-5.43,2.44-5.43,5.43C61.57,42.27,64.01,44.71,67,44.71z" />
                                              <ellipse transform="matrix(0.9902 -0.1397 0.1397 0.9902 -5.5624 9.9592)" className="st8" cx="68.17" cy="44.61" rx="5.43" ry="5.43" />
                                              <path className="st8" d="M51.15,48.83c2.07,0,3.77-1.69,3.77-3.77s-1.69-3.77-3.77-3.77c-2.07,0-3.77,1.69-3.77,3.77S49.08,48.83,51.15,48.83z" />
                                              <path className="st8" d="M48.08,53.3c1.78,0,3.23-1.45,3.23-3.23c0-1.78-1.45-3.23-3.23-3.23c-1.78,0-3.23,1.45-3.23,3.23C44.85,51.85,46.3,53.3,48.08,53.3z" />
                                              <path className="st8" d="M47.26,58.88c1.78,0,3.23-1.45,3.23-3.23c0-1.78-1.45-3.23-3.23-3.23c-1.78,0-3.23,1.45-3.23,3.23C44.03,57.42,45.48,58.88,47.26,58.88z" />
                                              <path className="st8" d="M74.31,45.34c2.07,0,3.77-1.69,3.77-3.77s-1.69-3.77-3.77-3.77c-2.07,0-3.77,1.69-3.77,3.77S72.24,45.34,74.31,45.34z" />
                                              <path className="st8" d="M78.67,47.06c1.78,0,3.23-1.45,3.23-3.23c0-1.78-1.45-3.23-3.23-3.23s-3.23,1.45-3.23,3.23C75.44,45.6,76.89,47.06,78.67,47.06z" />
                                              <path className="st8" d="M82.96,49.71c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C80.05,48.4,81.36,49.71,82.96,49.71z" />
                                              <path className="st8" d="M85.86,53.85c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C82.95,52.55,84.26,53.85,85.86,53.85z" />
                                              <path className="st8" d="M85.99,58.79c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C83.08,57.48,84.39,58.79,85.99,58.79z" />
                                              <path className="st8" d="M86.39,63.33c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C83.47,62.03,84.78,63.33,86.39,63.33z" />
                                              <path className="st8" d="M47.15,62.68c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C44.24,61.37,45.55,62.68,47.15,62.68z" />
                                              <path className="st8" d="M48.95,64.2c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C46.04,62.89,47.35,64.2,48.95,64.2z" />
                                              <path className="st8" d="M49.3,60.73c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C46.39,59.43,47.7,60.73,49.3,60.73z" />
                                              <path className="st8" d="M49.16,56.92c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C46.25,55.61,47.56,56.92,49.16,56.92z" />
                                              <path className="st8" d="M50.13,53.1c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C47.22,51.8,48.53,53.1,50.13,53.1z" />
                                              <path className="st8" d="M52.42,49.5c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C49.51,48.19,50.82,49.5,52.42,49.5z" />
                                              <path className="st8" d="M74.96,48.39c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C72.05,47.09,73.35,48.39,74.96,48.39z" />
                                              <path className="st8" d="M80,49.75c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C77.08,48.45,78.39,49.75,80,49.75z" />
                                              <path className="st8" d="M83.77,53.94c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C80.86,52.63,82.17,53.94,83.77,53.94z" />
                                              <path className="st8" d="M84.6,58.93c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C81.69,57.62,83,58.93,84.6,58.93z" />
                                              <path className="st8" d="M84.81,63.72c1.6,0,2.91-1.31,2.91-2.91c0-1.6-1.31-2.91-2.91-2.91c-1.6,0-2.91,1.31-2.91,2.91C81.9,62.41,83.21,63.72,84.81,63.72z" />
                                              <g>
                                                <g>
                                                  <g>
                                                    <rect x="43.78" y="61.37" transform="matrix(0.9926 -0.1217 0.1217 0.9926 -8.0023 5.9694)" className="st11" width="2.13" height="14.2" />
                                                    <path className="st12" d="M44.65,75.65c-3.63,0.45-6.96-2.35-7.43-6.24c-0.48-3.89,2.08-7.41,5.71-7.85L44.65,75.65z" />
                                                  </g>
                                                  <g>
                                                    <rect x="82.05" y="67.4" transform="matrix(0.1218 -0.9926 0.9926 0.1218 10.337 148.6199)" className="st11" width="14.2" height="2.13" />
                                                    <path className="st12" d="M89.34,75.65c3.63,0.45,6.96-2.35,7.43-6.24c0.48-3.89-2.08-7.41-5.71-7.85L89.34,75.65z" />
                                                  </g>
                                                  <path className="st11" d="M42.97,61.89c0-5.94,2.67-11.14,6.99-14.88c4.35-3.76,10.37-6.02,17.03-6.02c6.67,0,12.72,2.22,17.08,5.94c4.31,3.68,6.97,8.82,6.97,14.75h-2.15c0-5.26-2.37-9.84-6.21-13.12c-3.97-3.39-9.52-5.41-15.68-5.41c-6.13,0-11.66,2.06-15.63,5.49c-3.86,3.34-6.24,7.97-6.24,13.26H42.97z" />
                                                </g>
                                                <path className="st11" d="M66.97,88.59c9.5,0,21.4-4.21,22.51-14.06l-2.08-0.51c-1.05,8.44-12.06,12.41-20.43,12.41V88.59z" />
                                                <path className="st11" d="M65.63,85.29h3.92c1.12,0,2.04,0.92,2.04,2.04v0c0,1.12-0.92,2.04-2.04,2.04h-3.92c-1.12,0-2.04-0.92-2.04-2.04v0C63.58,86.21,64.5,85.29,65.63,85.29z" />
                                              </g>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      )}
                                      <div
                                        className="ctext-wrap"
                                        style={(mensaje.enviadoPor !== usuario.uuid && mensaje.enviadoPor !== 'unlogged') ?
                                          { borderRadius: '15px', borderTopLeftRadius: '0px', maxWidth: '80%', fontSize: '16px' } :
                                          { borderRadius: '15px', borderTopRightRadius: '0px', fontSize: '16px' }}
                                      >
                                        {mensaje.imgPre && (mensaje.imgAdjunto && !mensaje.imgAdjunto.includes(';base64')) && (
                                        <p>
                                          <i onClick={() => {
                                            cargarImagen(mensaje);
                                          }}
                                          >
                                            <img src={mensaje.imgPre} alt="" />
                                          </i>
                                        </p>
                                        )}
                                        {mensaje.imgAdjunto && mensaje.imgAdjunto.includes(';base64') && (
                                        <p>
                                          <img src={mensaje.imgAdjunto} alt="" />
                                        </p>
                                        )}
                                        <span style={{ whiteSpace: 'pre-line' }}>
                                          <TextoConEnlaces texto={mensaje.mensaje} />
                                        </span>
                                      </div>
                                    </div>
                                    <Row
                                      className="chat-time"
                                      style={(mensaje.enviadoPor !== usuario.uuid && mensaje.enviadoPor !== 'unlogged') ?
                                        { marginBotton: '24px', marginLeft: '50px', fontSize: '10px' } : { marginBotton: '24px', marginRight: '30px', fontSize: '10px', display: 'inline', float: 'right', clear: 'right' }}
                                    >
                                      {formatearFechaHora(mensaje.horaEnvio)}
                                    </Row>
                                    {mensaje.botones && (
                                    <Row
                                      style={{ marginTop: '0.5%', display: 'flex', justifyContent: 'center', height: 'fitContent', marginLeft: '20px' }}
                                      xs="1"
                                    >
                                      {mensaje.botones && mensaje.botones.map((b) => {
                                        return (
                                          <Col
                                            key={b.id}
                                            style={{
                                              marginBottom: '0.5%',
                                              fontSize: '14px',
                                              borderRadius: '15px'
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="botonChat"
                                              onClick={() => {
                                                onBotonChat(b.id, mensaje.idNodo, b.texto);
                                              }}
                                              style={{ minWidth: '50px' }}
                                            >
                                              {b.texto}
                                            </button>
                                          </Col>
                                        );
                                      })}
                                    </Row>
                                    )}
                                  </li>
                                );
                              }
                              if (mensaje.tipo && mensaje.tipo === 'formularioLogin') {
                                return (
                                  <li className="right">
                                    <div className="conversation-list" style={{ display: 'flex', marginBottom: '5px', float: 'right' }}>
                                      <Card
                                        style={{
                                          marginRight: window.innerWidth < '500px' ? '' : '25px',
                                          border: '1px',
                                          borderRadius: '15px',
                                          borderStyle: 'solid',
                                          padding: '20px',
                                          paddingBottom: '10px',
                                          minWidth: '150px',
                                          maxWidth: '400px'
                                        }}
                                      >
                                        <CardTitle style={{ display: 'flex', justifyContent: 'center' }}>
                                          {t('Please, complete the following form')}
                                        </CardTitle>
                                        <CardBody style={{ maxWidth: '75vw' }}>
                                          <Row>
                                            <Label>
                                              {t('Email')}
                                            </Label>
                                            <Input
                                              type="text"
                                              onChange={(e) => { setMailLogin(e.target.value); setEmailValidado(''); }}
                                              value={mailLogin}
                                              style={{ width: '88%', marginLeft: '10px' }}
                                              onBlur={() => validarEmailReal()}
                                              invalid={emailValidado === false && mailLogin !== ''}
                                            />
                                            <FormFeedback>
                                              {t('Email no valido')}
                                            </FormFeedback>
                                          </Row>
                                          <Row style={{ marginTop: '15px' }}>
                                            <Label>
                                              {t('Phone')}
                                            </Label>
                                            <PhoneInput
                                              onChange={setPhoneLogin}
                                              value={phoneLogin}
                                              enableSearch
                                              country={idiomaTelefono}
                                              inputStyle={{ maxWidth: '90%' }}
                                            />
                                          </Row>
                                          <Row style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                              color="primary"
                                              type="button"
                                              onClick={() => comprobarLogin()}
                                              style={{ width: 'fit-content' }}
                                              disabled={
                                                expandForm || uuid ||
                                                (phoneLogin.length < 5 && mailLogin === '') ||
                                                (mailLogin !== '' && !emailValidado)
                                              }
                                            >
                                              {t('Send')}
                                            </Button>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </div>
                                  </li>
                                );
                              }
                              if (mensaje.tipo && mensaje.tipo === 'formularioNombre') {
                                return (
                                  <li className="right">
                                    <div className="conversation-list" style={{ display: 'flex', marginBottom: '5px', float: 'right' }}>
                                      <Card
                                        style={{
                                          marginRight: '25px',
                                          border: '1px',
                                          borderRadius: '15px',
                                          borderStyle: 'solid',
                                          padding: '20px',
                                          paddingBottom: '10px',
                                          minWidth: '150px',
                                          maxWidth: '400px'
                                        }}
                                      >
                                        <CardTitle style={{ display: 'flex', justifyContent: 'center' }}>
                                          {t('How do you want to be referred as?')}
                                        </CardTitle>
                                        <CardBody style={{ maxWidth: '75vw' }}>
                                          <Row>
                                            <Label>
                                              {t('Name')}
                                            </Label>
                                            <Input
                                              type="text"
                                              onChange={(e) => setCurNombre(e.target.value)}
                                              value={curNombre}
                                              style={{ width: '88%', marginLeft: '10px' }}
                                            />
                                          </Row>
                                          <Row style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                              color="primary"
                                              type="button"
                                              onClick={() => registrarNuevo()}
                                              style={{ width: 'fit-content' }}
                                              disabled={uuid}
                                            >
                                              {t('Send')}
                                            </Button>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </div>
                                  </li>
                                );
                              }
                              if (mensaje.tipo && mensaje.tipo === 'escribiendo') {
                                return (
                                  <li className="">
                                    <div className="conversation-list" style={{ display: 'flex', marginBottom: '5px' }}>
                                      <div className="ctext-wrap ellipsis">
                                        <span>·</span>
                                        <span>·</span>
                                        <span>·</span>
                                      </div>
                                    </div>
                                  </li>
                                );
                              }
                              return '';
                            })}
                          </PerfectScrollbar>
                        </ul>
                      </div>
                      <div className="p-3 chat-input-section">
                        <Row>
                          <Col>
                            <div className="position-relative">
                              <input
                                type="text"
                                value={curMessage}
                                onChange={e => {
                                  setcurMessage(e.target.value);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' && !/^\s*$/.test(curMessage)) {
                                    enviarMensaje();
                                    mensajeEnviarIA.current += ' ';
                                  }
                                }}
                                className="form-control chat-input"
                                placeholder={`${t('Enter Message')}...`}
                                ref={textArea}
                                style={{ fontSize: '16px' }}
                              />
                              <div className="chat-input-links">
                                <ul className="list-inline mb-0">
                                  <li className="list-inline-item">
                                    <Tooltip
                                      placement="bottom-start"
                                      target="Emojitooltip"
                                      isOpen={menuEmojis}
                                      style={{ all: 'unset' }}
                                    >
                                      <div
                                        ref={wrapperRef}
                                        style={{ display: 'block' }}
                                        id="pickerContainer"
                                      />
                                    </Tooltip>
                                    <Link to="#">
                                      <i
                                        className="mdi mdi-emoticon-happy-outline me-1"
                                        id="Emojitooltip"
                                        onClick={() => setMenuEmojis(!menuEmojis)}
                                      />
                                      <UncontrolledTooltip placement="top" target="Emojitooltip">
                                        {t('Emojis')}
                                      </UncontrolledTooltip>
                                    </Link>
                                  </li>
                                  <li className="list-inline-item">
                                    <Link to="#">
                                      <i
                                        className="mdi mdi-file-image-outline me-1"
                                        id="Imagetooltip"
                                        onClick={() => setModalImage(true)}
                                      />
                                      <UncontrolledTooltip placement="top" target="Imagetooltip">
                                        {t('Images')}
                                      </UncontrolledTooltip>
                                    </Link>
                                  </li>
                                  <li className="list-inline-item">
                                    <Link to="#">
                                      <i
                                        className="mdi mdi-camera"
                                        id="Filetooltip"
                                        onClick={() => setModalCamara(true)}
                                      />
                                      <UncontrolledTooltip placement="top" target="Filetooltip">
                                        {t('Camera')}
                                      </UncontrolledTooltip>
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </Col>
                          <Col className="col-auto">
                            <Button
                              type="button"
                              color="primary"
                              className="btn btn-primary btn-rounded chat-send w-md "
                              onClick={() => {
                                if (curMessage === '') {
                                  reiniciarConversacion();
                                  if (idActual !== 'inicio') {
                                    publicarEstadisticas('reiniciar');
                                    setCamino([...camino, 'reiniciar']);
                                  }
                                } else {
                                  enviarMensaje();
                                  mensajeEnviarIA.current += ' ';
                                }
                              }}
                              disabled={/^\s+$/.test(curMessage)}
                            >
                              <span className="d-none d-sm-inline-block me-2">
                                {(curMessage !== '' || textoDiagramas.length === 0) ? t('Send') : t('Restart')}
                              </span>
                              {' '}
                              <i className="mdi mdi-send" />
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </Col>
            <Modal
              isOpen={modalCamara}
              toggle={() => setModalCamara(false)}
            >
              <div className="modal-header">
                <h5>
                  {t('Preview')}
                </h5>
                <button
                  type="button"
                  onClick={() => {
                    setModalCamara(false);
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Webcam screenshotFormat="image/jpeg" ref={webcamRef} style={{ width: '100%' }} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => {
                    setModalCamara(false);
                  }}
                  className="btn btn-secondary "
                  data-dismiss="modal"
                >
                  {t('Cancel')}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={capture}
                >
                  {t('Send')}
                </button>
              </div>
            </Modal>
            <Modal
              isOpen={modalImage}
              toggle={() => setModalImage(false)}
            >
              <Dropzone
                onSubmit={(files) => enviarImagen(files[0].file)}
                accept="image/gif, image/jpeg, image/png"
                inputContent={t('Drag Files or Click to Browse')}
                getUploadParams=""
                onChangeStatus=""
                maxFiles={1}
                multiple={false}
                styles={{
                  dropzone: { overflow: 'hidden', border: '0px' },
                  dropzoneActive: { overflow: 'hidden', border: '0px' }
                }}
                disabled={files => files.some(f => ['preparing', 'getting_upload_params', 'uploading'].includes(f.meta.status))}
              />
            </Modal>
          </Row>
        </Container>
      </div>
      {mostrarCopy && (
        <footer style={{ textAlign: 'center' }}>
          &copy; Journeytok
        </footer>
      )}
    </>
  );
};

Chat.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(Chat);
